import { memo } from 'react';
import { LogoIcon } from '../assets/icons/LogoIcon';
import { LogoManager } from '../assets/icons/LogoManager';
import { SettingIcon } from '../assets/icons/SettingIcon';
import { EdtiIcon } from '../assets/icons/EdtiIcon';
import { ListIcon } from '../assets/icons/ListIcon';
import { MyListIcon } from '../assets/icons/MyListIcon';
import { PeopleIcon } from '../assets/icons/PeopleIcon';
import { HamIcon } from '../assets/icons/HamIcon';
import { CloseIcon } from '../assets/icons/CloseIcon';
import { CloseBgIcon } from '../assets/icons/CloseBgIcon';
import { KingBgIcon } from '../assets/icons/KingBgIcon';
import { UserIcon } from '../assets/icons/UserIcon';
import { StarIcon } from '../assets/icons/StarIcon';
import { ResetIcon } from '../assets/icons/ResetIcon';
import { SearchIcon } from '../assets/icons/SearchIcon';
import { PlusIcon } from '../assets/icons/PlusIcon';
import { DateIcon } from '../assets/icons/DateIcon';
import { AutoOffIcon } from '../assets/icons/AutoOffIcon';
import { AutoOnIcon } from '../assets/icons/AutoOnIcon';
import { LoudSpeakerIcon } from '../assets/icons/LoudSpeakerIcon';
import { EditIcon } from '../assets/icons/EditIcon';
import { LineAddIcon } from '../assets/icons/LineAddIcon';
import { PourListIcon } from '../assets/icons/PourListIcon';
import { MarkerIcon } from '../assets/icons/MarkerIcon';
import { MapIcon } from '../assets/icons/MapIcon';
import { EntrySiteIcon } from '../assets/icons/EntrySiteIcon';
import { TrashIcon } from '../assets/icons/TrashIcon';
import { MinusIcon } from '../assets/icons/MinusIcon';
import { CheckIcon } from '../assets/icons/CheckIcon';
import { CheckActiveIcon } from '../assets/icons/CheckActiveIcon';
import { ArrowLeftIcon } from '../assets/icons/ArrowLeftIcon';
import { ArrowBottomIcon } from '../assets/icons/ArrowBottomIcon';
import { ArrowBottomBgIcon } from '../assets/icons/ArrowBottomBgIcon';
import { ArrowTopBgIcon } from '../assets/icons/ArrowTopBgIcon';
import { ArrowCurveIcon } from '../assets/icons/ArrowCurveIcon';
import { ArrowTopBottomIcon } from '../assets/icons/ArrowTopBottomIcon';
import { ArrowPrevIcon } from '../assets/icons/ArrowPrevIcon';
import { ArrowPrevDoubleIcon } from '../assets/icons/ArrowPrevDoubleIcon';
import { ArrowNextIcon } from '../assets/icons/ArrowNextIcon';
import { ArrowNextDoubleIcon } from '../assets/icons/ArrowNextDoubleIcon';

const icons = {
  // 아이콘 이름과 컴포넌트 매핑
  // 아이콘이 추가되면 아래 배열에 추가
  LogoIcon: LogoIcon,
  LogoManager: LogoManager,
  SettingIcon: SettingIcon,
  EdtiIcon: EdtiIcon,
  ListIcon: ListIcon,
  MyListIcon: MyListIcon,
  PeopleIcon: PeopleIcon,
  HamIcon: HamIcon,
  CloseIcon: CloseIcon,
  CloseBgIcon: CloseBgIcon,
  KingBgIcon: KingBgIcon,
  UserIcon: UserIcon,
  StarIcon: StarIcon,
  ResetIcon: ResetIcon,
  SearchIcon: SearchIcon,
  PlusIcon: PlusIcon,
  DateIcon: DateIcon,
  AutoOffIcon: AutoOffIcon,
  AutoOnIcon: AutoOnIcon,
  LoudSpeakerIcon: LoudSpeakerIcon,
  EditIcon: EditIcon,
  LineAddIcon: LineAddIcon,
  PourListIcon: PourListIcon,
  MarkerIcon: MarkerIcon,
  MapIcon: MapIcon,
  EntrySiteIcon: EntrySiteIcon,
  TrashIcon: TrashIcon,
  MinusIcon: MinusIcon,
  CheckIcon: CheckIcon,
  CheckActiveIcon: CheckActiveIcon,
  ArrowLeftIcon: ArrowLeftIcon,
  ArrowBottomIcon: ArrowBottomIcon,
  ArrowBottomBgIcon: ArrowBottomBgIcon,
  ArrowTopBgIcon: ArrowTopBgIcon,
  ArrowCurveIcon: ArrowCurveIcon,
  ArrowTopBottomIcon: ArrowTopBottomIcon,
  ArrowPrevIcon: ArrowPrevIcon,
  ArrowPrevDoubleIcon: ArrowPrevDoubleIcon,
  ArrowNextIcon: ArrowNextIcon,
  ArrowNextDoubleIcon: ArrowNextDoubleIcon,
} as const;

type IconName = keyof typeof icons;

interface IconProps {
  name: IconName;
  size: string;
  color: string;
  color2?: string;
}

export const Icon = memo(({ name, size, color, color2 }: IconProps) => {
  const IconComponent = icons[name];
  return <IconComponent size={size} color={color} color2={color2} />;
});

Icon.displayName = 'Icon';
